import styled from 'styled-components';
import { Badge, ButtonType, formatCountToMaxNinetyNine, IconButton, IconName, Tooltip } from '@optimus-web/core';
import {
    BADGE_OFFSET_WITH_AMOUNT,
    BADGE_OFFSET_WITHOUT_AMOUNT,
    TOOLTIP_MAX_WIDTH,
    TOOLTIP_OFFSET,
} from '../../modules/appNavbar/constants';

const TooltipedWrapper = Tooltip(styled.span`
    display: inline-block;
    position: relative;
`);

const CommanderNavbarIconButton = styled(IconButton)`
    border: none;
    width: 40px;
    height: 40px;
    box-sizing: border-box;
`;

interface Props {
    title?: React.ReactNode;
    count?: number;
    warning?: boolean;
    icon: IconName;
    onClick?(): void;
    type?: ButtonType;
}

const NavbarIconButton = (props: Props) => {
    const { title, count, warning, type = 'submit', ...other } = props;
    const displayAmount = count && count !== 0 ? formatCountToMaxNinetyNine(count) : undefined;

    return (
        <TooltipedWrapper tooltip={title} maxWidth={TOOLTIP_MAX_WIDTH} offset={TOOLTIP_OFFSET}>
            <Badge
                active={warning || !!displayAmount}
                offset={displayAmount ? BADGE_OFFSET_WITH_AMOUNT : BADGE_OFFSET_WITHOUT_AMOUNT}
                content={displayAmount}
            >
                <CommanderNavbarIconButton iconSize="medium" variant="ghost" type={type} {...other} />
            </Badge>
        </TooltipedWrapper>
    );
};

export default NavbarIconButton;
